/* tslint:disable */
import {
  Institutions,
  VoteHeads,
  FundsAccount
} from '../index';

declare var Object: any;
export interface FundsExpenditureInterface {
  "expended_amount": number;
  "year_expended": number;
  "institution_id": number;
  "funds_account_id": number;
  "id"?: number;
  "vote_head_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  institutions?: Institutions;
  voteHeads?: VoteHeads;
  fundsAccount?: FundsAccount;
}

export class FundsExpenditure implements FundsExpenditureInterface {
  "expended_amount": number;
  "year_expended": number;
  "institution_id": number;
  "funds_account_id": number;
  "id": number;
  "vote_head_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  institutions: Institutions;
  voteHeads: VoteHeads;
  fundsAccount: FundsAccount;
  constructor(data?: FundsExpenditureInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FundsExpenditure`.
   */
  public static getModelName() {
    return "FundsExpenditure";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FundsExpenditure for dynamic purposes.
  **/
  public static factory(data: FundsExpenditureInterface): FundsExpenditure{
    return new FundsExpenditure(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FundsExpenditure',
      plural: 'FundsExpenditures',
      path: 'FundsExpenditures',
      properties: {
        "expended_amount": {
          name: 'expended_amount',
          type: 'number'
        },
        "year_expended": {
          name: 'year_expended',
          type: 'number'
        },
        "institution_id": {
          name: 'institution_id',
          type: 'number'
        },
        "funds_account_id": {
          name: 'funds_account_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "vote_head_id": {
          name: 'vote_head_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        institutions: {
          name: 'institutions',
          type: 'Institutions',
          model: 'Institutions'
        },
        voteHeads: {
          name: 'voteHeads',
          type: 'VoteHeads',
          model: 'VoteHeads'
        },
        fundsAccount: {
          name: 'fundsAccount',
          type: 'FundsAccount',
          model: 'FundsAccount'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/FundsExpenditure.ts